import { render } from "./bookingform.vue?vue&type=template&id=e15dfa74"
import script from "./bookingform.vue?vue&type=script&lang=js"
export * from "./bookingform.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__